import routes from './routes'
import { Fetch } from '../fetch'

class InitServices {
  async getEquipmentTypes () {
    return Fetch('get', routes.EQUIPMENT_TYPES)
  }

  getTimeZone () {
    return Fetch('get', routes.TIME_ZONE)
  }
}

export default new InitServices()
